import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import AnimatedRoutes from './components/RouteTransitions/AnimatedRoutes';
import { SpeedInsights } from '@vercel/speed-insights/react';
import './App.css';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <MotionConfig reducedMotion="user">
        <Router>
          <AnimatedRoutes />
          <SpeedInsights />
        </Router>
      </MotionConfig>
    </HelmetProvider>
  );
};

export default App;
